import { useState, useEffect, useRef } from "react";

interface optionsType {
  method?: string;
  body?: any;
  authToken?: string;
}

const useFetch = (url: string, { method, body, authToken }: optionsType) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const [lastFetch, setLastFetch] = useState(0);

  const refetch = useRef(() => {
    setLastFetch(Date.now());
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setData(null);
      setError(null);
      try {
        const response = await fetch(url, {
          method: method || "GET",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authToken || "",
          },
          body: JSON.stringify(body),
        });
        const data = await response.json();
        setData(data);
      } catch (error) {
        setError(error);
      }
      setLoading(false);
    };
    fetchData();
  }, [url, method, body, authToken, lastFetch]);

  return { data, loading, error, refetch: refetch.current };
};

export default useFetch;
